// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from "vue";
import App from "./App";
import MetaInfo from "vue-meta-info";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import '../src/assets/css/component.css'
import '../src/assets/css/editor.css'
import animated from 'animate.css'
import vueMetaInfo from './assets/vue-meta-info' //seo 优化
// import vueMetaInfo from 'vue-meta-info'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import store from './store'
import router from "./router";
import '@/permission' // permission control
import moment from 'moment'
import _ from 'lodash'
import sidebar from '@/common/sidebar'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

Vue.prototype.$moment = moment;
Vue.prototype._ = _;
Vue.config.productionTip = false;
Vue.use(MetaInfo);
Vue.use(VueAwesomeSwiper);
Vue.use(ElementUI);
Vue.use(animated);
Vue.use(Viewer);
Vue.use(VideoPlayer)
Viewer.setDefaults({
  Options: {
    'inline': true,
    'button': true,
    'navbar': true,
    'title': true,
    'toolbar': true,
    'tooltip': true,
    'movable': true,
    'zoomable': true,
    'rotatable': true,
    'scalable': true,
    'transition': true,
    'fullscreen': true,
    'keyboard': true,
    'prev': true,
    'next': true,
    'url': 'data-source'
  }
})
Vue.prototype.$metaInfo = vueMetaInfo
/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })
Vue.component('sidebar',sidebar)


new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  template: "<App/>",
  // 添加mounted，不然不会执行预编译
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app');


//加入百度统计
router.beforeEach((to,from,next)=>{
  if(to.path){
    if(window._hmt){
      window._hmt.push(['_trackPageview',to.fullPath])
    }
  }
  console.log("main函数执行")
  next();
})





// WEBPACK FOOTER //
// ./src/main.js